<template>
	<b-container fluid class="px-1">    
    <b-row class="justify-content-center" no-gutters>
      <b-col xs="12" md="8" class="p-2">
        <b-tabs fill card vertical>
          <b-tab title="TUTORIALS" disabled>
          </b-tab>
          <b-tab title="IMPORTANT NOTES!" active>
            <b-card-text>
              <h4 style="text-align: center;">IMPORTANT NOTES!</h4><br>
              <p>
                - This Software is just a tool to help you using Telegram APIs to scrape and send messages to Telegram users, If you get flagged by Telegram or your accounts APIs are limited or blocked for some reason that only Telegram knows, please don’t ask our support team about why I’m blocked because Only Telegram API Support can answer your questions.<br><br>
              - Our technical support is replying to all questions about Silverdor products installation problems or any other issue related to the Silverdor products (Not Telegram APIs).<br><br>
              <span style="color: red;">- In case of Issues check the last tutorial section first. Silverdor’s support team will not respond to any message about the already explained Telegram ‘Errors’ and the answered FAQs.</span>
              </p>
              
            </b-card-text>
          </b-tab>
          <b-tab title="INTRODUCTION TO SILVERDOR DM" lazy>
            <b-card-text>
              <h4 style="text-align: center;">INTRODUCTION TO SILVERDOR DM</h4><br>
              <p>Silverdor DM Sender is and automation software, developed to handle usernames scraping from Telegram group and channel, and also send messages automatically to the scraped list. Silverdor comes with an all in one pack, helping business owners to target Telegram users.<br><br>

              The setting area is the most important part of the software. To do the work correctly and safely,  you will learn how to set up your software before proceeding any tasks.<br><br>

              In this tutorial we will present things in a logic order, so please follow the same steps and all will be fine:<br><br>

              1) Installation & Activation,<br>
              2) Get your Telegram API<br>
              3) Software Settings<br>
              4) Silverdor features<br>
              6) FAQ & Errors</p>
            </b-card-text>
          </b-tab>
          <b-tab title="INSTALLATION & ACTIVATION" lazy>
            <b-card-text>
              <h4 style="text-align: center;">INSTALLATION & ACTIVATION</h4><br>
              <p>
                After purchasing the the product, we have sent to you an email including your download link (for windows and Mac OS), and your username and license key.<br><br>

                To install and activate your Silverdor DM Sender :<br><br>

                1) Download the software version using the link provided, depending on your operating system.<br><br>
                2) Installation:<br>
                For Windows: Unzip "SilverdorDM_Windows.zip" and execute the Silverdor setup , follow the windows installation manager steps. <br>
                For Mac OS: Unzip "SilverdorDM_Mac.zip" and place "SiverdorDMSender.app" somewhere in your device<br><br>
                3) Make sure you’re connected to the internet before passing to the next step.<br><br>
                4) Open the Software:<br> 
                For Windows: Double click on the desktop icon.<br>
                For Mac OS: Follow these steps:<br>
                a) Click right on "SiverdorDMSender.app" then click "Show Package Contents"<br>
                b) Open "Content" folder then open "MacOs" folder, then double click "SiverdorDMSender" exec file.<br>
                c) A terminal will open, please wait until the software is opened. (Keep the terminal opened while using the software, close it after closing the software.)<br><br>
                5) An activation window will appear, copy/past your ‘username’ and ‘license key’ as provided by email, click ‘activate’.<br>
              </p>
              <b-img center fluid src="https://silverdormanager.univerhome.com/uploads/media/activation.jpg" alt="Silverdor-activate"></b-img><br>
              <p>
                5) Enjoy.<br><br>
                If you have problems with your installation or with the activation
              <a href="/Support">Contact us</a></p>
             
            </b-card-text>
          </b-tab>
          <b-tab title="GET YOUR TELEGRAM API" lazy>
            <b-card-text>
              <h4 style="text-align: center;">GET YOUR TELEGRAM API</h4><br>
              <p>Note: if You already have your APIs credentials for your accounts, Skip this step.<br><br>

                We think that you have finished with the installation and the activation of the software. Before start using Silverdor you should start with:<br><br>

              1) Create a Telegram account with your phone number ‘+123456789’. If you have already one that’s fine.<br>
              2) Go to  <a href="https://my.telegram.org/auth">https://my.telegram.org/auth</a> use your phone number to create your Telegram application then get your API information.</p><br>
              <b-img center fluid src="https://silverdormanager.univerhome.com/uploads/media/apispace-1024x457.jpg" alt="apis"></b-img><br>
              <p>
                3) Fill out your app form like this example:<br><br><br>
                  – App title : Enter your own title.<br>
                  – Short name: Enter your own short name.<br>
                  – URL: Let it empty it's optional (recommended).<br>
                  – Platform: Enter "Desktop" (Highly recommended).<br><br>
                4) Telegram will provide your API information, you will need just these two codes:
                the ‘api_id‘ and the ‘api_hash‘, example:<br><br>
                api_id: 111111<br>
                api_hash: 6e9ef2a436kkkke174d2fb7bebba7a5c<br><br>
                Now you have your api code related to your Telegram account. (each account has a unique  API id/hash)
              </p>

            </b-card-text>
          </b-tab>
          <b-tab title="SOFTWARE SETTINGS" lazy>
            <b-card-text>
              <h4 style="text-align: center;">SOFTWARE SETTINGS</h4><br>

              To setup your software you should open the Silverdor settings window:<br> 
              - On Windows click file>Settings <br>
              - On Mac click SilverdorDMSender>preferences<br><br>

              <u>1°) Scraping Settings tab:</u><br><br>
              <b-img center fluid src="https://silverdormanager.univerhome.com/uploads/media/silverdor-dm-sender-scraping-settings.png" alt="apis"></b-img><br><br>

              Configure how to proceed usernames scraping by setting the following parameters:<br><br>
              <b>Scrape From</b>: Set from where you want to get usernames (GROUP, GROUP_MESSAGES or CHANNEL_COMMENTS)<br>
              <b>Status All or Recently</b>: For GROUP option do you want all or just recently active users.<br>
              <b>Group Messages Limit</b>: For GROUP_MESSAGES option how much messages to fetch per group.<br>
              <b>Channel Posts Limit</b>: For CHANNEL_COMMENTS option how much posts to fetch per channel.<br><br>

              <u>2°) Sending Settings tab:</u><br><br>
              <b-img center fluid src="https://silverdormanager.univerhome.com/uploads/media/silverdor-dm-sender-sending-settings.png" alt="apis"></b-img><br><br>

              Configure how to send messages to usernames by setting the following parameters:<br><br>
              <b>Daily Limit</b>: Daily limit of Messages per each account.<br>
              <b>Random Sleep Delay</b>: Min and Max wait time in seconds to choose from randomly (sleep between messages)<br>
              <b>Auto Resend</b>: When the software finish sending to all user, do you want to restart automatically.<br><br>

              <u>3°) Proxies Settings tab:</u><br><br>
              <b-img center fluid src="https://silverdormanager.univerhome.com/uploads/media/silverdor-dm-sender-proxies-settings.png" alt="apis"></b-img><br><br>
              Enable proxies and set the proxy mode by setting the following parameters:<br><br>
              <b>Enable Proxies</b>: If enabled, accounts will be connected through the uploaded proxies.<br>
              <b>Proxies mode</b>: Set to SINGLE if you want to use one proxy for all accounts, or MULTIPLE to use each account with his own proxy (in this case the list of proxies should cover all uploaded accounts, e.g for 5 accounts you need 5 proxies)<br><br>
            </b-card-text>
          </b-tab>


          <b-tab title="SILVERDOR DM FEATURES" lazy>
            <b-card-text>
              <h4 style="text-align: center;">SILVERDOR DM FEATURES</h4><br>
              <p>Silverdor DM Sender provides a nice and flexible interface, there are 4 main areas in the software window:</p><br>
              <b-img center fluid src="https://silverdormanager.univerhome.com/uploads/media/silverdor-dm-sender-main.png" alt="apis"></b-img><br><br>
              <p><u>1°) Yellow Area:</u><br><br>
               This area represents the first step to do after setting up your software.<br><br>
              This area is reserved for uploading necessary data like: Accounts list, Group/Channel list, Messages list, Proxies list and Session files (after clicking a button you will see instructions about what to upload and how to upload it). buttons on the left are for uploading, buttons on the right are for showing or managing uploaded data.<br><br>

              <u>2°) Blue Area:</u><br><br>
              This area represents the second step to do after uploading your data from the previous step.<br><br>
              After uploading your accounts, you need to click "Start Initializing Accounts". Accounts connections will be checked one by one, The software will show instructions through the checking process.<br><br>

            
              <u>3°) Red Area:</u><br><br>
              This area represents the Third step to do after Initializing Accounts from the previous step.<br><br>
              From this area you can Start/Stop scraping usernames and manage the scraped list, you can import, export, delete.... The progress status or error messages will be shown bellow the buttons.<br><br>

              <u>4°) Green Area:</u><br><br>
              This area represents the final step to do after scraping usernames from the previous step.<br><br>
              You can Start sending messages or Stop the sending process. The progress status or error messages will be shown bellow the buttons.<br><br></p>
            </b-card-text>
          </b-tab>

          <b-tab title="FAQ & ERRORS" lazy>
            <b-card-text>
              <h4 style="text-align: center;">FAQ & ERRORS</h4><br>
              <p>

                <b>FloodError:</b><br><br>

                It means your account has been temporarily flagged from scraping/sending by Telegram for a period of time. Silverdor DM Sender will automatically stop using the flooded accounts and will continue using the active accounts for scraping and sending. In case all accounts got flooded the process will be stopped.<br><br>

                

                <b>FAQs:</b><br><br>

                <b>Can Silverdor team unblock me from sending flood?</b><br>
                Please consider that Silverdor team has no control on Telegram side, Silverdor is an automation interface between you and Telegram. All messages or errors received are coming from Telegram not Silverdor.<br><br>

                <b>I have a problem editing a CSV file?</b><br>

                To avoid issues, edit CSV files preferably with Notepad or a similar text editor, data should be separated by comma ",".
              </p>
            </b-card-text>
          </b-tab>

        </b-tabs>
      </b-col>
    </b-row>
	</b-container> 
</template>

<script>
export default {
 
  data() {
    return {
    };
  },

  methods:{
 
  },

  components: { 
  },

  computed: {
  }
};
</script>
<style scoped>


</style>